import axios, { AxiosInstance } from 'axios';
import { useAuthenticatedAxios } from './useAuthenticatedAxios';

interface PlaylistData {
  playlistId: string;
  playlistName: string;
  playlistDescription: string;
  playlistPicUrl: string | null;
}

interface PlaylistResponse {
  success: boolean;
  message: string;
  data: PlaylistData[];
}

interface MediaData {
  mediaId: string;
  mediaName: string;
  mediaDescription: string;
  mediaPicUrl: string | null;
}

interface MediaResponse {
  success: boolean;
  message: string;
  data: MediaData[];
}

export const mediaService = {
  listMedia: async (api: AxiosInstance) => {
    // const api = useAuthenticatedAxios();
    try {
      const response = await api.get('/media/listMedia');
      return response.data;
    } catch (error) {
      console.error('Error fetching media:', error);
      throw error;
    }
  },
  listMediaByPlaylist: async (api: AxiosInstance, playlistId: string): Promise<MediaResponse> => {
    try {
      const response = await api.get(`/media/list?playlistId=${playlistId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching media by playlist:', error);
      throw error;
    }
  },
  getMediaUrl: async (api:AxiosInstance, mediaName: string) => {
    // const api = useAuthenticatedAxios();
    try {
      const response = await api.get(`/media/getUrl?mediaName=${mediaName}`);
      return response.data.url;
    } catch (error) {
      console.error('Error fetching media URL:', error);
      throw error;
    }
  },
  createMedia: async (
    api: AxiosInstance,
    file: File,
    mediaName: string,
    mediaDescription: string,
    playlistId: string
  ) => {
    try {
      const formData = new FormData();
      formData.append('media', file);
      formData.append(
        'data',
        JSON.stringify({ mediaName, mediaDescription, playlistId })
      );
      const response = await api.post('/media/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading media:', error);
      throw error;
    }
  },
};

export const playlistService = {
  listPlaylists: async (api: AxiosInstance): Promise<PlaylistResponse> => {
    try {
      const response = await api.get('/playlist/list');
      return response.data;
    } catch (error) {
      console.error('Error fetching playlists:', error);
      throw error;
    }
  },
  createPlaylist: async (
    api: AxiosInstance,
    playlistName: string,
    playlistDescription: string,
    playlistPicUrl: string
  ) => {
    try {
      const response = await api.post('/playlist/create', {
        playlistName,
        playlistDescription,
        playlistPicUrl,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating playlist:', error);
      throw error;
    }
  },
};

// export default api; 